module.exports = __webpack_public_path__ + "static/img/sub.c1c20b9e.png";